import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { DEFAULT_LANGUAGE } from 'constants/languages';
import { captionsPrefsSelector } from 'redux/modules/user-pref/selectors';
import { parseSearch } from 'utils/routes';
import { VideoTranscriptWizardLocationOptions } from 'utils/routes/types';
import { isVideoFlowStep } from './flows/utils';

export default function useVideoWizardDefaults() {
  const defaultLanguage = useSelector(
    state => captionsPrefsSelector(state).captionLanguage ?? DEFAULT_LANGUAGE,
  );

  const location = useLocation();
  const { search } = location;

  const {
    defaultAspectRatio,
    defaultObjective,
    defaultStep,
  }: VideoTranscriptWizardLocationOptions = parseSearch(search) ?? {};

  return {
    defaultAspectRatio,
    defaultLanguage,
    defaultObjective,
    defaultStep: isVideoFlowStep(defaultStep) ? defaultStep : undefined,
  };
}
